export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-=[\]{}|;:'",.<>?/`~.]{8,32}$/;

export const attendeeListDropdown = [
  { label: "Pending", value: "UNSEND" },
  { label: "Sent", value: "SENT" },
  { label: "Don't Send", value: "DONT_SEND" },
  { label: "Unsubscribed", value: "UNSUBSCRIBED" },
  { label: "Failed", value: "FAILED" },
];

export const API_OPTIONS = [
  { label: "YES", value: "YES" },
  { label: "NO", value: "NO" },
];

export const SMTP_OPTIONS = [
  { label: "YES", value: "YES" },
  { label: "NO", value: "NO" },
];
